import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  summary: {
    color: colour.grey[300],
    marginTop: 10,
    marginBottom: 20
  },
  chartWrapper: {
    width: "100%",
    height: 625,
    border: `1px solid ${colour.grey[500]}`,
    borderRadius: 3,
    display: 'flex',
    flexWrap: 'wrap'
  },
  titleWrapper: {
    flex: 'none',
    width: "100%",
    borderBottom: `1px solid ${colour.grey[500]}`,
    paddingBottom: 12,
    paddingTop: 1
  },
  chartTitle: {
    display: 'flex',
    textAlign: "left",
    fontSize: 14,
    fontWeight: 600,
    color: colour.grey[300],
    marginTop: 10,
    marginLeft: 10
  },
  chart2Column: {
    width: '50% !important',
    height: '460px !important'
  },
  chart3Column: {
    width: '33.333% !important',
    height: '460px !important'
  },
  legend: {
    borderTop: `1px solid ${colour.grey[500]}`,
    width: '100%',
    margin: 10,
    fontSize: 14,
    fontWeight: 600
  },
  img: {
    verticalAlign: 'text-top',
    marginLeft: 10,
    marginRight: 10
  },
  line: {
    width: 5,
    height: 3,
    display: 'inline-block',
    marginLeft: 10,
    marginRight: 10,
    width: 16,
    verticalAlign: 'middle',
    borderTop: `2px dotted ${colour.grey[300]}`
  }
});
